module.exports = __webpack_public_path__ + "img/SB.51b4e2a1.png";